(function () {
  const root = document.getElementById('rasa-quiz-root');
  const anchor = document.getElementById('rasa-quiz');

  if (!root) return;

  const handles = {
    ruby: root.dataset.rubyHandle,
    black: root.dataset.blackHandle,
    rose: root.dataset.roseHandle,
    discovery: root.dataset.discoveryHandle, // multipack
    longevityDuo: root.dataset.longevityDuoHandle,
    dewySkinDuo: root.dataset.dewySkinDuoHandle
  };

  const CATS = [
    "CALM", "ENERGY", "DIGESTIVE", "IMMUNE", "FOCUS", "MOOD", "ANTI_INFLAM", "SLEEP", "RECOVERY", "CIRCULATION", "LONGEVITY", "SKIN"
  ];

  function emptyScores() {
    return Object.fromEntries(CATS.map(k => [k, 0]));
  }

  const state = {
    step: 0,
    scores: emptyScores(),
    flavor: null,
    identity: null, // "MEN_PERF" | "WOMEN_RITUAL" | "NEUTRAL"
    products: {} // handle -> product json
  };

  const quiz = [
    {
      id: "goal",
      title: "1. What does your body need most right now?",
      subtitle: "Select one.",
      type: "single",
      options: [
        { label: "Recovery & performance", add: { RECOVERY: 5, CIRCULATION: 3, ENERGY: 2 } },
        { label: "Longevity & cellular resilience", add: { LONGEVITY: 5, ANTI_INFLAM: 2 } },
        { label: "Calm nervous system & stress resilience", add: { CALM: 5, MOOD: 2, SLEEP: 1 } },
        { label: "Digestive comfort & gut support", add: { DIGESTIVE: 5 } },
        { label: "Jitter-free energy", add: { ENERGY: 5, FOCUS: 2 } },
        { label: "Mood uplift & emotional balance", add: { MOOD: 5, CALM: 2 } },
        { label: "Immune & respiratory support", add: { IMMUNE: 5 } },
        { label: "Skin vitality & glow", add: { SKIN: 5, MOOD: 2, CALM: 1 } },
        { label: "I want the full ritual (all benefits)", add: { LONGEVITY: 3, RECOVERY: 3, CALM: 3, IMMUNE: 3, DIGESTIVE: 3, SKIN: 3 } }
      ]
    },
    {
      id: "science_break",
      title: "A note on Rasāsvāda science",
      type: "info",
      body: `
        <p>When we say science-based, we mean it. Rasāsvāda’s formulas have been tested by longevity scientists.</p>
        <ul>
          <li><strong>Longevity study:</strong> Rasāsvāda’s formulations increased the median lifespan of <em>C. elegans</em> by up to <strong>32%</strong>.</li>
          <li><strong>Blood vessel growth study:</strong> Black Ginger increased healthy blood vessel growth by <strong>100%</strong> in in vitro human cells within <strong>24 hours</strong> compared to a control.</li>
        </ul>
        <p style="opacity:.8;font-size:.9rem;">More testing is needed to understand the full impact on humans. This research is not intended to diagnose, treat, cure, or prevent any disease.</p>
      `
    },
    {
      id: "identity",
      title: "2. Which statement sounds most like you?",
      type: "identity",
      options: [
        { label: "I train hard and want faster recovery.", identity: "MEN_PERF", add: { RECOVERY: 4, CIRCULATION: 3, ENERGY: 2 } },
        { label: "I optimize for longevity and track metrics (HRV, VO₂, sleep, labs).", identity: "MEN_PERF", add: { LONGEVITY: 4, FOCUS: 2, ANTI_INFLAM: 1 } },
        { label: "I love Traditional Chinese Medicine / herbs / yoga rituals.", identity: "WOMEN_RITUAL", add: { CALM: 3, MOOD: 3, DIGESTIVE: 1 } },
        { label: "I want a nightly ritual.", identity: "WOMEN_RITUAL", add: { CALM: 4, SKIN: 3, SLEEP: 2, MOOD: 2 } },
        { label: "None of these exactly — I just want what works.", identity: "NEUTRAL", add: { } }
      ]
    },
    {
      id: "timing",
      title: "3. When will you most often drink Rasāsvāda?",
      type: "single",
      options: [
        { label: "In the morning", add: { ENERGY: 2, FOCUS: 1 } },
        { label: "Pre-workout / movement", add: { RECOVERY: 3, CIRCULATION: 2, ENERGY: 1 } },
        { label: "After meals", add: { DIGESTIVE: 3 } },
        { label: "Afternoon reset", add: { FOCUS: 2, MOOD: 1 } },
        { label: "Evening unwind", add: { CALM: 3, MOOD: 2, SLEEP: 1, SKIN: 1 } },
        { label: "Before bed", add: { SLEEP: 4, CALM: 2 } }
      ]
    },
    {
      id: "body_state",
      title: "4. What’s been most true lately?",
      subtitle: "Select up to 2 responses.",
      type: "multi",
      max: 2,
      options: [
        { label: "Slow recovery after training", add: { RECOVERY: 3 } },
        { label: "Cold hands/feet or circulation feels “off”", add: { CIRCULATION: 3 } },
        { label: "Wired but tired", add: { CALM: 3, SLEEP: 1 } },
        { label: "Brain fog", add: { FOCUS: 3 } },
        { label: "Bloating / digestive discomfort", add: { DIGESTIVE: 3 } },
        { label: "Inflamed / achy", add: { ANTI_INFLAM: 3 } },
        { label: "Stress / anxious / overstimulated", add: { CALM: 3 } },
        { label: "Getting sick often", add: { IMMUNE: 3 } },
        { label: "Skin feels dull / want radiance", add: { SKIN: 3 } }
      ]
    },
    {
      id: "flavor",
      title: "5. Which flavor direction sounds best right now?",
      type: "flavor",
      options: [
        { label: "Bright citrus + floral", flavor: "CITRUS_FLORAL" },
        { label: "Tart / fruity botanical", flavor: "TART_BOTANICAL" },
        { label: "Warming spice (ginger/cardamom)", flavor: "WARMING_SPICE" },
        { label: "Earthy / complex botanicals", flavor: "EARTHY_COMPLEX" },
        { label: "Light & refreshing", flavor: "LIGHT_REFRESHING" },
        { label: "Adventurous — surprise me", flavor: "ADVENTUROUS" }
      ]
    }
  ];

  const productProfiles = {
    ruby: { LONGEVITY: 5, DIGESTIVE: 4, ENERGY: 4, ANTI_INFLAM: 3, MOOD: 2, SKIN: 2, CALM: 1 },
    black: { RECOVERY: 5, CIRCULATION: 5, ANTI_INFLAM: 2, LONGEVITY: 4, FOCUS: 2, SLEEP: 2 },
    rose: { CALM: 4, MOOD: 4, IMMUNE: 3, SKIN: 3 },
    longevityDuo: { LONGEVITY: 5, RECOVERY: 5, CIRCULATION: 4, ENERGY: 3, ANTI_INFLAM: 3, FOCUS: 2 },
    dewySkinDuo: { SKIN: 5, CALM: 4, MOOD: 4, LONGEVITY: 3, DIGESTIVE: 2 },
    discovery: { LONGEVITY: 3, RECOVERY: 3, CALM: 3, MOOD: 3, DIGESTIVE: 2, IMMUNE: 2, SKIN: 2, CIRCULATION: 2, ENERGY: 2 }
  };

  const flavorAffinity = {
    CITRUS_FLORAL: { rose: 3, ruby: 1, black: 0, discovery: 2, longevityDuo: 1, dewySkinDuo: 2 },
    TART_BOTANICAL: { ruby: 3, rose: 1, black: 0, discovery: 2, longevityDuo: 2, dewySkinDuo: 2 },
    WARMING_SPICE: { black: 3, ruby: 1, rose: 0, discovery: 2, longevityDuo: 3, dewySkinDuo: 1 },
    EARTHY_COMPLEX: { black: 2, ruby: 2, rose: 0, discovery: 2, longevityDuo: 2, dewySkinDuo: 1 },
    LIGHT_REFRESHING: { rose: 2, ruby: 1, black: 0, discovery: 2, longevityDuo: 1, dewySkinDuo: 2 },
    ADVENTUROUS: { discovery: 3, ruby: 1, black: 1, rose: 1, longevityDuo: 2, dewySkinDuo: 2 }
  };

  function dot(a, b) {
    let s = 0;
    for (const k of Object.keys(a)) s += (a[k] || 0) * (b[k] || 0);
    return s;
  }

  function addScores(add) {
    for (const [k, v] of Object.entries(add || {})) {
      if (state.scores[k] == null) state.scores[k] = 0;
      state.scores[k] += v;
    }
  }

  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Failed to load product: ${handle}`);
    return res.json();
  }

  function money(cents) {
    const n = (cents / 100).toFixed(2);
    return `$${n}`;
  }

  function findSizeVariants(product) {
    const variants = product.variants || [];
    const out = { "375ml": null, "750ml": null };

    for (const v of variants) {
      const t = (v.public_title || v.title || "").toLowerCase();
      if (t.includes("375")) out["375ml"] = v;
      if (t.includes("750")) out["750ml"] = v;
    }

    if ((!out["375ml"] || !out["750ml"]) && variants.length === 2) {
      const sorted = [...variants].sort((a, b) => a.price - b.price);
      out["375ml"] = out["375ml"] || sorted[0];
      out["750ml"] = out["750ml"] || sorted[1];
    }
    return out;
  }

  async function addToCart(variantId, qty = 1) {
    const res = await fetch(`/cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    });
    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || "Add to cart failed");
    }
    return res.json();
  }

  function topTwoCats(scores) {
    const arr = Object.entries(scores).sort((a, b) => b[1] - a[1]);
    return arr.slice(0, 2).map(([k]) => k);
  }

  function computeRecommendation() {
    const base = {};
    for (const [key, profile] of Object.entries(productProfiles)) {
      base[key] = dot(state.scores, profile);
    }

    if (state.flavor && flavorAffinity[state.flavor]) {
      const aff = flavorAffinity[state.flavor];
      for (const k of Object.keys(base)) base[k] += (aff[k] || 0);
    }

    if (state.identity === "MEN_PERF") {
      base.black += 2; base.longevityDuo += 3;
    } else if (state.identity === "WOMEN_RITUAL") {
      base.rose += 2; base.dewySkinDuo += 3;
    }

    const sorted = Object.entries(base).sort((a, b) => b[1] - a[1]);
    const top1 = sorted[0], top2 = sorted[1], top3 = sorted[2];
    const closeTop3 = (top1[1] - top3[1]) <= 4;

    if (closeTop3) return { primary: "discovery", secondary: top1[0], upgrade: null };

    const primary = top1[0];
    let upgrade = null;

    if (primary === "black") upgrade = "longevityDuo";
    if (primary === "ruby") {
      const skinStrong = (state.scores.SKIN || 0) >= 4;
      const calmStrong = (state.scores.CALM || 0) >= 5;
      upgrade = (skinStrong || calmStrong) ? "dewySkinDuo" : "longevityDuo";
    }
    if (primary === "rose") upgrade = "dewySkinDuo";
    if (primary === "longevityDuo" || primary === "dewySkinDuo") upgrade = "discovery";

    return { primary, secondary: top2[0], upgrade };
  }

  function el(html) {
    const d = document.createElement('div');
    d.innerHTML = html.trim();
    return d.firstChild;
  }

  function render(scroll) {
    const totalSteps = quiz.length;
    const q = quiz[state.step];

    const pct = Math.round(((state.step) / (totalSteps)) * 100);

    root.innerHTML = "";
    const card = el(`<div class="rasa-card"></div>`);
    root.appendChild(card);

    const prog = el(`
      <div class="rasa-quiz-progress">
        <div class="rasa-quiz-step">Step ${Math.min(state.step + 1, totalSteps)} of ${totalSteps}</div>
        <div class="rasa-quiz-progressbar" aria-hidden="true"><div style="width:${pct}%;"></div></div>
      </div>
    `);
    card.appendChild(prog);

    if (q?.type === "info") {
      const body = el(`
        <div class="rasa-q">
          <h3>${q.title}</h3>
          <div>${q.body}</div>
          <div class="rasa-actions">
            <button class="primary" data-next>Continue</button>
            <button class="link" data-back>Back</button>
          </div>
        </div>
      `);
      card.appendChild(body);
      bindInfo();
      return;
    }

    if (state.step >= quiz.length) {
      renderResults(card);
      return;
    }

    const container = el(`
      <div class="rasa-q">
        <h3 style="margin-bottom:0.5em">${q.title}</h3>
        <div style="font-size:0.9rem;opacity:0.8;margin-bottom:2em">${q.subtitle || ''}</div>
        <div class="rasa-answers"></div>
        <div class="rasa-actions">
          <button class="link" data-back ${state.step === 0 ? "disabled" : ""}>Back</button>
        </div>
      </div>
    `);

    const answers = container.querySelector('.rasa-answers');

    if (q.type === "single" || q.type === "flavor" || q.type === "identity") {
      q.options.forEach((opt, idx) => {
        const b = el(`<button class="rasa-btn" data-idx="${idx}">${opt.label}</button>`);
        answers.appendChild(b);
      });
    } else if (q.type === "multi") {
      q.options.forEach((opt, idx) => {
        const b = el(`<button class="rasa-btn" data-idx="${idx}" aria-pressed="false">${opt.label}</button>`);
        answers.appendChild(b);
      });
      const next = el(`<div class="rasa-actions"><button class="primary" data-next>Continue</button></div>`);
      container.appendChild(next);
    }

    card.appendChild(container);
    bindQuestion(q, container);

    if(scroll !== false) {
      anchor.scrollIntoView();
    }
  }

  function bindInfo() {
    root.querySelector('[data-next]')?.addEventListener('click', () => { state.step++; render(); });
    root.querySelector('[data-back]')?.addEventListener('click', () => { state.step = Math.max(0, state.step - 1); render(); });
  }

  function bindQuestion(q, container) {
    const back = container.querySelector('[data-back]');
    if (back) back.addEventListener('click', () => { state.step = Math.max(0, state.step - 1); render(); });

    if (q.type === "single") {
      container.querySelectorAll('.rasa-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const opt = q.options[Number(btn.dataset.idx)];
          addScores(opt.add);
          state.step++;
          render();
        });
      });
    }

    if (q.type === "identity") {
      container.querySelectorAll('.rasa-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const opt = q.options[Number(btn.dataset.idx)];
          state.identity = opt.identity;
          addScores(opt.add);
          state.step++;
          render();
        });
      });
    }

    if (q.type === "flavor") {
      container.querySelectorAll('.rasa-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const opt = q.options[Number(btn.dataset.idx)];
          state.flavor = opt.flavor;
          state.step = quiz.length;
          render();
        });
      });
    }

    if (q.type === "multi") {
      const selected = new Set();
      container.querySelectorAll('.rasa-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const idx = Number(btn.dataset.idx);
          if (selected.has(idx)) {
            selected.delete(idx);
            btn.setAttribute("aria-pressed", "false");
          } else {
            if (selected.size >= (q.max || 2)) return;
            selected.add(idx);
            btn.setAttribute("aria-pressed", "true");
          }
        });
      });

      container.querySelector('[data-next]')?.addEventListener('click', () => {
        selected.forEach(idx => addScores(q.options[idx].add));
        state.step++;
        render();
      });
    }
  }

  function benefitBullets(primaryKey) {
    if (primaryKey === "black" || primaryKey === "longevityDuo") {
      return ["Circulation & vascular vitality", "Workout recovery pathways", "Clean sustained energy"];
    }
    if (primaryKey === "ruby" || primaryKey === "dewySkinDuo") {
      return ["Cellular resilience & longevity support", "Digestive activation", "Inflammatory balance"];
    }
    if (primaryKey === "rose") {
      return ["Nervous system calm", "Mood support", "Radiant vitality"];
    }
    return ["Longevity + recovery + calm (complete ritual)", "Explore all three flavors", "Best for first-time discovery"];
  }

  function scienceSnippet(primaryKey) {
    if (primaryKey === "black" || primaryKey === "longevityDuo") {
      return `Black Ginger increased healthy blood vessel growth by <strong>100%</strong> in in vitro human cells within <strong>24 hours</strong> compared to a control (preclinical research).`;
    }
    if (primaryKey === "ruby" || primaryKey === "dewySkinDuo") {
      return `Rasāsvāda’s formulations increased the median lifespan of <em>C. elegans</em> by up to <strong>32%</strong> (model-system research).`;
    }
    if (primaryKey === "rose") {
      return `Rose Bergamot is formulated for calm, mood, and radiant vitality using traditional botanical principles (TCM-inspired).`;
    }
    return `Explore longevity, circulation/recovery, and calm/glow across all three rituals.`;
  }

  function titleFor(key) {
    return ({
      ruby: "Ruby Artemisia",
      black: "Black Ginger",
      rose: "Rose Bergamot",
      discovery: "Discovery Set (All 3)",
      longevityDuo: "Longevity Duo (Ruby + Black Ginger)",
      dewySkinDuo: "Dewy Skin Duo (Ruby + Rose)"
    })[key] || key;
  }

  function handleFor(key) {
    return ({
      ruby: handles.ruby,
      black: handles.black,
      rose: handles.rose,
      discovery: handles.discovery,     // multipack
      longevityDuo: handles.longevityDuo,
      dewySkinDuo: handles.dewySkinDuo
    })[key];
  }

  async function ensureProductsLoaded(keys) {
    const unique = [...new Set(keys)].filter(Boolean);
    await Promise.all(unique.map(async (k) => {
      const handle = handleFor(k);
      if (!handle) return;
      if (state.products[handle]) return;
      state.products[handle] = await fetchProduct(handle);
    }));
  }

  function renderPick(key, emphasisLabel) {
    const handle = handleFor(key);
    const product = state.products[handle];
    const variantsBySize = product ? findSizeVariants(product) : { "375ml": null, "750ml": null };

    const defaultSize = variantsBySize["750ml"] ? "750ml" : "375ml";
    const defaultVariant = variantsBySize[defaultSize] || variantsBySize["375ml"] || variantsBySize["750ml"];

    const imageUrl = product?.featured_image || "";
    const imageHtml = imageUrl
      ? `<div class="rasa-pick__img"><img src="${imageUrl}" alt="${titleFor(key)}" loading="lazy"></div>`
      : "";

    return el(`
      <div class="rasa-pick" data-pick="${key}">
        <div class="rasa-pick__inner">
          ${imageHtml}
          <div class="rasa-pick__content">
            <h4>${emphasisLabel ? `${emphasisLabel}: ` : ""}${titleFor(key)}</h4>
            <p>${key === "discovery" ? "Try all three rituals — longevity, circulation/recovery, and calm/glow." : "Personalized match based on your answers."}</p>

            <div class="rasa-variant-row">
              <label>
                <div class="t-body-smaller cr-gray-l">Size</div>
                <div class="rasa-select-wrapper">
                  <select class="rasa-select" data-size>
                    ${variantsBySize["375ml"] ? `<option value="375ml">375ml</option>` : ""}
                    ${variantsBySize["750ml"] ? `<option value="750ml">750ml</option>` : ""}
                  </select>
                </div>
              </label>

              <div>
                <div class="t-body-smaller cr-gray-l">Price</div>
                <div class="rasa-price" data-price>${defaultVariant ? money(defaultVariant.price) : ""}</div>
              </div>

              <button class="btn bg-green" data-add ${defaultVariant ? "" : "disabled"} style="margin-left:auto">
                Add to cart
              </button>
            </div>

            <div class="rasa-toast rasa-hidden" data-toast></div>
          </div>
        </div>
      </div>
    `);
  }

  async function renderResults(card) {
    card.querySelector('.rasa-quiz-progress')?.classList.add('rasa-hidden');

    const rec = computeRecommendation();
    const primary = rec.primary;
    const upgrade = rec.upgrade;

    await ensureProductsLoaded([primary, upgrade, "discovery"].filter(Boolean));

    const bullets = benefitBullets(primary).map(x => `<li>${x}</li>`).join("");
    const topCats = topTwoCats(state.scores).map(x => x.replaceAll("_", " ").toLowerCase()).join(" + ");

    const wrap = el(`
      <div class="rasa-result-grid">
        <div class="rasa-result-hero">
          <h3>Your Ritual: ${titleFor(primary)}</h3>
          <p style="margin:0;opacity:.9;">Based on your answers, you’re optimizing <strong>${topCats}</strong> — with a flavor match that fits your palate.</p>
          <div class="rasa-badges">
            <span class="rasa-badge">Personalized ritual</span>
            <span class="rasa-badge">Science-informed</span>
            <span class="rasa-badge">Alcohol-free</span>
          </div>
        </div>

        <div class="rasa-why">
          <h4>Why it matches you</h4>
          <ul style="margin:8px 0 0 18px;opacity:.95;">${bullets}</ul>
          <p class="rasa-note" style="margin-top:10px;">
            <strong>Research exploration:</strong> ${scienceSnippet(primary)}
          </p>
          <p class="rasa-note">
            *Preclinical research. More testing is needed to understand impacts in humans.
          </p>
        </div>

        <div data-picks></div>

        <div class="rasa-actions">
          <button class="link" data-restart>Restart quiz</button>
        </div>
      </div>
    `);

    const picks = wrap.querySelector('[data-picks]');
    picks.appendChild(renderPick(primary, "Your match"));

    if (upgrade && upgrade !== primary) {
      picks.appendChild(renderPick(upgrade, "Most customers like you choose"));
    }

    if (primary !== "discovery" && upgrade !== "discovery") {
      picks.appendChild(renderPick("discovery", "Go deeper"));
    }

    card.appendChild(wrap);
    bindPicks(card);

    wrap.querySelector('[data-restart]')?.addEventListener('click', () => {
      state.step = 0;
      state.scores = emptyScores();
      state.flavor = null;
      state.identity = null;
      render();
    });
  }

  function bindPicks(card) {
    const pickEls = card.querySelectorAll('[data-pick]');
    pickEls.forEach(pickEl => {
      const key = pickEl.dataset.pick;
      const handle = handleFor(key);
      const product = state.products[handle];
      if (!product) return;

      const variantsBySize = findSizeVariants(product);
      const sizeSel = pickEl.querySelector('[data-size]');
      const priceEl = pickEl.querySelector('[data-price]');
      const addBtn = pickEl.querySelector('[data-add]');
      const toast = pickEl.querySelector('[data-toast]');

      const defaultSize = (variantsBySize["375ml"] && "375ml") || (variantsBySize["750ml"] && "750ml") || null;
      if (defaultSize && sizeSel) sizeSel.value = defaultSize;

      const currentVariant = variantsBySize[defaultSize] || variantsBySize["375ml"] || variantsBySize["750ml"];
      if (priceEl && currentVariant) priceEl.textContent = money(currentVariant.price);

      sizeSel?.addEventListener('change', () => {
        const v = variantsBySize[sizeSel.value];
        if (v && priceEl) priceEl.textContent = money(v.price);
      });

      addBtn?.addEventListener('click', async () => {
        const size = sizeSel ? sizeSel.value : "750ml";
        const v = variantsBySize[size] || variantsBySize["375ml"] || variantsBySize["750ml"];
        if (!v) return;

        addBtn.disabled = true;
        addBtn.textContent = "Adding…";
        toast.classList.add('rasa-hidden');
        toast.textContent = "";

        try {
          await addToCart(v.id, 1);
          addBtn.textContent = "Added ✓";
          toast.textContent = "Added to cart.";
          toast.classList.remove('rasa-hidden');
          if (typeof globalThis.reloadCartItems === 'function') globalThis.reloadCartItems();
          setTimeout(() => {
            document.documentElement.classList.add('minicart-is-active');
            history.pushState(null, null, '#cart');
            if (typeof globalThis.scrollDisable === 'function') globalThis.scrollDisable();
          }, 400);
        } catch (e) {
          addBtn.textContent = "Add to cart";
          toast.textContent = "Sorry — couldn’t add to cart. Please try again.";
          toast.classList.remove('rasa-hidden');
          console.error(e);
        } finally {
          setTimeout(() => {
            addBtn.disabled = false;
            addBtn.textContent = "Add to cart";
          }, 1200);
        }
      });
    });
  }

  render(false);

})();
